import { App, Button, Card, Col, Divider, Form, Input, Row, Select } from 'antd'
import React, { useState } from 'react'
import Heading from '../../common/Heading/Heading'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { addItems, getItemGroups, getPriceLists, getStockUoms } from '../../../network/Item';
import { useNavigate } from 'react-router';
const ItemAdd = ({ t, edit, services }) => {
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { mutate: onAddItems } = useMutation({
    mutationKey: [services ? 'addServices' : 'addItems'],
    mutationFn: (body) => (edit ? addItems(body) : addItems(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      // client.invalidateQueries({ queryKey: [ services ? queryKeys.getServices : queryKeys.getItems] });
      client.invalidateQueries({ queryKey: [queryKeys.getItems] });
      form.resetFields();
      navigate(services ? '/servicesPage' : '/items');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const { data: itemGroups } = useQuery({
    queryKey: [queryKeys.getItemGroups],
    queryFn: () => getItemGroups(),
    keepPreviousData: true,
  });
  const { data: stockUoms } = useQuery({
    queryKey: [queryKeys.getStockUoms],
    queryFn: () => getStockUoms(),
    keepPreviousData: true,
  });
  const { data: priceLists } = useQuery({
    queryKey: [queryKeys.getPriceLists],
    queryFn: () => getPriceLists(),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    console.log('Finish:', values);
    onAddItems({
      inventoryData: JSON.stringify({
        ...values,
        is_stock_item: services ? '0' : '1',
      }),
    });
  };
  return (
    <div className="item-add">
      <Heading title={ services ? t.services : t.items} 
      subTitle={ services ? (edit ? t.editService : t.addService) : (edit ? t.editItems : t.addtems)} 
      path= {services ? "/servicesPage" : "/items"} />
      <Card>
        <h4 className="title-card">{t.eNTERLABTESTINFORMATION}</h4>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
        >
          <Divider orientation="left">{t.inventoryInformation}</Divider>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="item_code"
                label={t.itemName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.itemName} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="item_group"
                label={t.itemGroups}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t.itemGroups}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={itemGroups?.message.item_groups?.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="stock_uom"
                label={t.unitofMeasure}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  showSearch
                  placeholder={t.unitofMeasure}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={stockUoms?.message.item_groups?.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="is_stock_item"
                label={t.maintainStock}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  // showSearch
                  placeholder={t.maintainStock}
                  options={[
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '2' },
                  ]}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="include_item_in_manufacturing"
                label={t.includeItemInManufacturing}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  // showSearch
                  placeholder={t.includeItemInManufacturing}
                  options={[
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '2' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="shelf_life_in_days"
                label={t.shelfLifeInDays}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input type="number" placeholder={t.shelfLifeInDays} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="description"
                label={t.description}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input.TextArea
                  autoSize={{ minRows: 4, maxRows: 6 }}
                  placeholder={t.description}
                />
              </Form.Item>
            </Col>
            <Divider orientation="left">{t.itemPrice}</Divider>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="price_list"
                label={t.priceList}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t.priceList}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={priceLists?.message?.price_lists?.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="currency"
                label={t.currency}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input type="text" placeholder={t.currency} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="price_list_rate"
                label={t.rate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input type="number" placeholder={t.rate} />
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate('items')}>
            {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default ItemAdd